import React, { useEffect, useState } from "react";
import back from "../../assets/back.svg";
import { useNavigate, useParams } from "react-router-dom";
import { AdminButton } from "../../components/buttons/versionHistoryBtn";
import { useDispatch } from "react-redux";
import {
  DivisionDetail,
  productDivisionList,
  fieldForceDivisionList,
  doctorDivisionList,
  pharmacyDivisionList,
} from "../../redux/actions/divisionAction";
import DivisionViewTable from "./divisionViewTable";
import PharmacyDivisionView from "../../components/division/pharmacy/PharmacyDivisionView";
import PharmacyDivisionList from "../../components/division/pharmacy/PharmacyDivisionList";
import DoctorDivisionView from "../../components/division/doctor/DoctorDivisionView";
import FieldForceDivisionView from "../../components/division/fieldforce/FieldForceDivisionView";
import FieldForceDivisionList from "../../components/division/fieldforce/FieldForceDivisionList";
import ProductDivisionView from "../../components/division/product/ProductDivisionView";
import ProductDivisionList from "../../components/division/product/ProductDivisionList";
import DoctorDivisionList from "../../components/division/doctor/DoctorDivisionList";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import { NavLink } from "react-router-dom";
import LoadingSpinnerTable from "../../components/utilites/loader";
import BulkUploadModal from "../../components/modals/bulk-upload/bulk-upload-modal";

const DivisionView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [bulkUploadModalShow, setBulkUploadModalShow] = useState(false);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const is_subscribed = localStorage.getItem("is_subscribed");

  const [divisionViewData, setDivisionViewData] = useState("");
  const [activeTab, setActiveTab] = useState(1); // ACTIVE TAB
  const [activeProduct, setActiveProduct] = useState(11); // ACTIVE PRODUCT TAB
  const [activeFF, setActiveFF] = useState(21); // ACTIVE FIELD FORCE TAB
  const [activeDoctor, setActiveDoctor] = useState(31); // ACTIVE DOCTOR TAB
  const [activePharmacy, setActivePharmacy] = useState(41); // ACTIVE PHARMACY TAB
  const [productDivisionData, setProductDivisionData] = useState([]);
  const [ffDivisionData, setFfDivisionData] = useState([]);
  const [doctorDivisionData, setDoctorDivisionData] = useState([]);
  const [pharmacyDivisionData, setPharmacyDivisionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState("");
  const [selectedFfID, setselectedFfID] = useState("");
  const [selectedDoctorID, setSelectedDoctorID] = useState("");
  const [selectedPharmacyID, setSelectedPharmacyID] = useState("");

  console.log(divisionViewData?.id, "division id");

  useEffect(() => {
    setLoading(true);
    dispatch(
      DivisionDetail(params.id, onDivisionViewSuccess, onDivsionViewError)
    );

    dispatch(
      productDivisionList(
        { division_id: params.id },
        onProductDivViewSuccess,
        onProductDivViewError
      )
    );

    dispatch(
      fieldForceDivisionList(
        { division_id: params.id },
        onFfDivViewSuccess,
        onFfDivViewError
      )
    );
    dispatch(
      doctorDivisionList(
        { division_id: params.id },
        onDoctorDivViewSuccess,
        onDoctorDivViewError
      )
    );

    dispatch(
      pharmacyDivisionList(
        { division_id: params.id },
        onPharmacyDivViewSuccess,
        onPharmacyDivViewError
      )
    );
  }, []);

  const onDivisionViewSuccess = (data) => {
    setLoading(false);
    setDivisionViewData(data.data.data);
    console.log(data);
  };

  const onDivsionViewError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const onProductDivViewSuccess = (data) => {
    setProductDivisionData(data.data.data);
    console.log(data);
  };

  const onProductDivViewError = (err) => {
    console.log(err);
  };

  const onFfDivViewSuccess = (data) => {
    setFfDivisionData(data.data.data);
    console.log(data);
  };

  const onFfDivViewError = (err) => {
    console.log(err);
  };

  const onDoctorDivViewSuccess = (data) => {
    setDoctorDivisionData(data.data.data);
    console.log(data);
  };

  const onDoctorDivViewError = (err) => {
    console.log(err);
  };

  const onPharmacyDivViewSuccess = (data) => {
    setPharmacyDivisionData(data.data.data);
    console.log(data);
  };

  const onPharmacyDivViewError = (err) => {
    console.log(err);
  };

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/division",
      breadcrumb: " / division",
    },
    {
      path: "/division/view",
      breadcrumb: " / view",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <div className="search-container d-flex justify-content-between ">
              <div
                className="d-flex align-items-center p-2 ms-3 m-1 mb-2"
                onClick={() => navigate(-1)}
              >
                <img src={back} alt="back_btn" />
                <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                  BACK
                </span>
              </div>
              <div className=" d-flex justify-content-between m-1 mb-2 align-items-center">
                {is_subscribed == "false" && (
                  <AdminButton
                    background="#2AD3E7"
                    className="text-uppercase"
                    color="white"
                    width="190px"
                    onClick={() => setBulkUploadModalShow(true)}
                  >
                    <span className="m-2"> Upload Bulk data</span>
                  </AdminButton>
                )}
                <AdminButton
                  background="#7065E4"
                  color="white"
                  width="100px"
                  onClick={() =>
                    navigate(`/division/edit/${divisionViewData.id}`)
                  }
                >
                  <span className="m-2">EDIT</span>
                </AdminButton>
              </div>
            </div>
            <div style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <div className="scrolling">
                  <div className="main-view-page">
                    <DivisionViewTable divisionViewData={divisionViewData} />
                    <>
                      <div className="d-xl-block mx-4">
                        <div
                          className="d-flex my-1 py-2 "
                          style={{ overflowX: "scroll" }}
                        >
                          <div className="text-nowrap my-1">
                            <button
                              className={
                                activeTab == 1
                                  ? "topbarTabActive mx-2"
                                  : "topTab mx-2"
                              }
                              onClick={() => {
                                setActiveTab(1);
                              }}
                            >
                              Products
                            </button>
                          </div>
                          <div className="text-nowrap my-1">
                            <button
                              className={
                                activeTab == 2
                                  ? "topbarTabActive mx-2"
                                  : "topTab mx-2"
                              }
                              onClick={() => {
                                setActiveTab(2);
                              }}
                            >
                              Field force
                            </button>
                          </div>
                          <div className="text-nowrap my-1">
                            <button
                              className={
                                activeTab == 3
                                  ? "topbarTabActive mx-2"
                                  : "topTab mx-2"
                              }
                              onClick={() => {
                                setActiveTab(3);
                              }}
                            >
                              Doctors
                            </button>
                          </div>
                          <div className="text-nowrap my-1">
                            <button
                              className={
                                activeTab == 4
                                  ? "topbarTabActive mx-2"
                                  : "topTab mx-2"
                              }
                              onClick={() => {
                                setActiveTab(4);
                              }}
                            >
                              Pharmacies
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="view-main-container mx-4">
                        {activeTab == 1 && (
                          <>
                            {activeProduct == 11 && (
                              <ProductDivisionList
                                setActiveProduct={setActiveProduct}
                                productDivisionData={productDivisionData}
                                setSelectedProductId={setSelectedProductId}
                                loading={loading}
                              />
                            )}
                            {activeProduct == 12 && (
                              <ProductDivisionView
                                selectedProductId={selectedProductId}
                                setActiveProduct={setActiveProduct}
                              />
                            )}
                          </>
                        )}
                        {activeTab === 2 && (
                          <>
                            {activeFF == 21 && (
                              <FieldForceDivisionList
                                setActiveFF={setActiveFF}
                                ffDivisionData={ffDivisionData}
                                setselectedFfID={setselectedFfID}
                              />
                            )}
                            {activeFF == 22 && (
                              <FieldForceDivisionView
                                setActiveFF={setActiveFF}
                                data={selectedFfID}
                              />
                            )}
                          </>
                        )}
                        {activeTab === 3 && (
                          <>
                            {activeDoctor == 31 && (
                              <DoctorDivisionList
                                is_subscribed={is_subscribed}
                                setActiveDoctor={setActiveDoctor}
                                doctorDivisionData={doctorDivisionData}
                                setSelectedDoctorID={setSelectedDoctorID}
                                DivisionId={divisionViewData?.id}
                                doctorDivisionList={doctorDivisionList}
                              />
                            )}
                            {activeDoctor == 32 && (
                              <DoctorDivisionView
                                setActiveDoctor={setActiveDoctor}
                                selectedDoctorID={selectedDoctorID}
                              />
                            )}
                          </>
                        )}
                        {activeTab === 4 && (
                          <>
                            {activePharmacy == 41 && (
                              <PharmacyDivisionList
                                is_subscribed={is_subscribed}
                                setActivePharmacy={setActivePharmacy}
                                pharmacyDivisionData={pharmacyDivisionData}
                                setSelectedPharmacyID={setSelectedPharmacyID}
                                DivisionId={divisionViewData?.id}
                                pharmacyDivisionList={pharmacyDivisionList}
                              />
                            )}
                            {activePharmacy == 42 && (
                              <PharmacyDivisionView
                                setActivePharmacy={setActivePharmacy}
                                selectedPharmacyID={selectedPharmacyID}
                              />
                            )}
                          </>
                        )}
                      </div>
                    </>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <BulkUploadModal
        ShowClose={() => setBulkUploadModalShow(false)}
        show={bulkUploadModalShow}
        DivisionData={divisionViewData?.id}
      />
    </>
  );
};

export default DivisionView;
